import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { APP_NOTIFY_EVENT } from '../../utils/notifications';

const ToastViewport = () => {
  const { theme } = useTheme();
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const handleNotify = (event) => {
      const detail = event.detail || {};
      if (!detail.message) {
        return;
      }

      setItems((current) => [...current, detail]);

      window.setTimeout(() => {
        setItems((current) => current.filter((item) => item.id !== detail.id));
      }, detail.duration || 10000);
    };

    window.addEventListener(APP_NOTIFY_EVENT, handleNotify);
    return () => window.removeEventListener(APP_NOTIFY_EVENT, handleNotify);
  }, []);

  if (!items.length) {
    return null;
  }

  const getToastStyle = (type) => {
    const colorMap = {
      success: {
        background: theme.colors.success,
        border: theme.colors.success,
        text: '#ffffff',
        accent: theme.colors.success,
      },
      error: {
        background: theme.colors.error,
        border: theme.colors.error,
        text: '#ffffff',
        accent: theme.colors.error,
      },
      info: {
        background: theme.colors.primary,
        border: theme.colors.primary,
        text: '#ffffff',
        accent: theme.colors.primary,
      },
    };

    const palette = colorMap[type] || colorMap.info;

    return {
      minWidth: '320px',
      maxWidth: '560px',
      padding: '12px 14px 12px 18px',
      borderRadius: '12px',
      border: `1px solid ${palette.border}`,
      backgroundColor: palette.background,
      color: palette.text,
      boxShadow: theme.shadows.xl,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      pointerEvents: 'auto',
      position: 'relative',
      overflow: 'hidden',
    };
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '16px',
        right: '16px',
        zIndex: 5000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '10px',
        pointerEvents: 'none',
      }}
    >
      {items.map((item) => (
        <div key={item.id} style={getToastStyle(item.type)}>
          <div
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              width: '6px',
              backgroundColor: item.type === 'success'
                ? theme.colors.success
                : item.type === 'error'
                  ? theme.colors.error
                  : theme.colors.primary,
            }}
          />
          <div style={{ paddingLeft: '8px', fontSize: '14px', fontWeight: '600', lineHeight: 1.4, flex: 1 }}>
            {item.message}
          </div>
          <button
            type="button"
            onClick={() => setItems((current) => current.filter((entry) => entry.id !== item.id))}
            style={{
              border: 'none',
              background: 'transparent',
              color: '#ffffff',
              fontSize: '18px',
              lineHeight: 1,
              cursor: 'pointer',
              padding: '0 2px',
            }}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastViewport;
